import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import dayjs from 'dayjs/esm'

import { SiteService } from './site.service'

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService 
{
	constructor(
			private http: HttpClient,
		@Inject('BASE_API_URL') private baseUrl: string,
			private siteService: SiteService,
			private router: Router
	) 
	{ 

	}

  	canActivate()
	{
		if (this.siteService.customerAccount.accountKnowledgeValidated)
		{
			const rightNow = dayjs()
			const sessionExpiry = dayjs(this.siteService.customerAccount.sessionExpiry)

			return (sessionExpiry.valueOf() > rightNow.valueOf())
		}
		else
		{
			this.router.navigate(['/validate-account'])
			return false
		} 
	}
}
